var map = {
	"./logo_union_3001.png": "e09f",
	"./logo_union_3002.png": "c15d",
	"./logo_union_3003.png": "b55b",
	"./logo_union_3004.png": "0966",
	"./logo_union_default.png": "6554"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4f65";